import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'

import { type CardIdType } from '@/defs/card'
import { getCardQuery } from '@/utils/cardUtil'

type Props = {
  cardId?: CardIdType
  enabled?: boolean
}

export const useCard = ({ cardId: cardIdProp, enabled = true }: Props) => {
  const [wasEverEnabled, setWasEverEnabled] = useState(enabled)
  if (enabled && !wasEverEnabled) setWasEverEnabled(true)

  const cardId = useMemo(() => (wasEverEnabled && cardIdProp ? cardIdProp : false), [wasEverEnabled, cardIdProp])

  const query = useMemo(() => getCardQuery(cardId), [cardId])

  const { data, isError, isLoading } = useQuery({ enabled: wasEverEnabled, ...query })

  return { card: data ? data : undefined, hasError: isError, loading: isLoading }
}
